import React from "react";

import { faExclamationTriangle } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./MeetingGuidelines.module.css";

interface ShortNoticeProps {
	eventStartDate: Date;
	setRendered: (rendered: boolean) => void;
	hoursInAdvanceThreshold: number;
}

export default function ShortNotice({ eventStartDate, setRendered, hoursInAdvanceThreshold }: ShortNoticeProps) {
	const shouldRenderPrompt = React.useMemo(() => {
		const currentDate = new Date();
		const hoursInAdvance = (eventStartDate.getTime() - currentDate.getTime()) / 1000 / 60 / 60;

		return hoursInAdvance >= 0 && hoursInAdvance <= hoursInAdvanceThreshold;
	}, [eventStartDate, hoursInAdvanceThreshold]);

	React.useEffect(() => {
		setRendered(shouldRenderPrompt);

		return () => {
			setRendered(false);
		};
	}, [setRendered, shouldRenderPrompt]);

	if (!shouldRenderPrompt) return null;

	return (
		<div className={styles.meetingPrompt}>
			<div className={styles.meetingPromptIcon}>
				<FontAwesomeIcon fixedWidth icon={faExclamationTriangle} />
			</div>
			<div>
				<div className={styles.headlineText}>Find another time for this meeting</div>
				<div className={styles.supportingText}>
					Your meetings must be booked more than {hoursInAdvanceThreshold} hour
					{hoursInAdvanceThreshold !== 1 ? "s" : ""} in advance.
				</div>
			</div>
		</div>
	);
}
